module.exports = __webpack_public_path__ + "img/413.eba89075.jpg";